import { Injectable } from "@angular/core";
import { ApiService } from "../api.service";
import { Observable } from "rxjs";

@Injectable()
export class CouponService {
  private apiPrefix = '/client/coupon';

  constructor(
    private api: ApiService,
  ) {
  }

  isValidCoupon(code: string, periodId?: number): Observable<any> {
    return this.api.post(`${this.apiPrefix}/is-valid-coupon`, {
      code,
      periodId,
    })
  }
}
